export default "__VITE_ASSET__ZQvTzVL___"